import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'

import { SEARCH, SearchContext } from '../search/SearchContext'
import { getHotels, preparePayloadForGetHotels } from '../helpers/hotelHelper'
import Arrow from '../common/icons/Arrow'

const HotelsPagination = () => {
  const { state, dispatch } = useContext(SearchContext)
  const _setFiltersOpen = (open) => dispatch({ type: SEARCH.FILTERS.OPEN, payload: open})
  const _setinitiatePageChange = (payload) => dispatch({ type: SEARCH.INITIATE_PAGE_CHANGE, payload })

  const _handlePageClick = (data) => {
    _setinitiatePageChange(true)
    let payload = preparePayloadForGetHotels(state.searchBy, state, true, data.selected + 1 )
    getHotels(dispatch, payload, state.displaySearchMessage, true)
    _setFiltersOpen(false)

    let list = document.querySelector(".left .scrollable")
    if(list) list.scrollTop = 0
  }

  const PrevButton = () => <span><Arrow /></span>
  const NextButton = () => <span><Arrow /></span>

  const _renderPagination = () => {
    if (!state.meta || (state.meta.total_pages < 2))
      return

    let startFrom = (state.meta.current_page - 1) * state.meta.per_page + 1
    let endTill = startFrom + state.hotels.length - 1

    return (
      <div className="pagination-container">
        <ReactPaginate
          previousLabel={PrevButton()}
          nextLabel={NextButton()}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={state.meta.total_pages}
          forcePage={state.meta.current_page - 1}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={_handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
        />
        <small className="showing">{startFrom}-{endTill} of {state.meta.total_count}</small>
      </div>
    )
  }

  return <React.Fragment>{ _renderPagination() }</React.Fragment>
}

HotelsPagination.propTypes = {
  setHotels: PropTypes.func.isRequired
}

export default HotelsPagination
